/* Drop Monday — Luxury Product Card behavior
   - Carousel prev/next + dots
   - Size selection (variant switching)
   - AJAX add-to-cart
*/

(function () {
  const moneyFormat = window.DM_MONEY_FORMAT || (window.Theme && window.Theme.money_format);

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return moneyFormat ? window.Shopify.formatMoney(cents, moneyFormat) : window.Shopify.formatMoney(cents);
      }
    } catch (e) {}
    // Fallback: raw currency (best-effort)
    const v = (Number(cents) / 100).toFixed(2);
    return v;
  }

  function initCardCarousel(card) {
    const media = card.querySelector('[data-dm-media]');
    const track = card.querySelector('[data-dm-track]');
    if (!media || !track) return;

    const dotsWrap = card.querySelector('[data-dm-dots]');
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.dm-dot')) : [];
    const prev = card.querySelector('[data-dm-prev]');
    const next = card.querySelector('[data-dm-next]');

    const updateDots = () => {
      if (!dots.length) return;
      const w = track.clientWidth || 1;
      const idx = Math.round(track.scrollLeft / w);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    };

    const scrollByOne = (dir) => {
      const w = track.clientWidth || 1;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); scrollByOne(-1); });
    if (next) next.addEventListener('click', (e) => { e.preventDefault(); scrollByOne(1); });
    track.addEventListener('scroll', () => window.requestAnimationFrame(updateDots), { passive: true });
  }

  function getVariants(card) {
    const el = card.querySelector('[data-dm-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function updatePrice(card, variant) {
    const priceWrap = card.querySelector('[data-dm-price]');
    if (!priceWrap || !variant) return;

    const now = formatMoney(variant.price);
    const was = variant.compare_at_price && variant.compare_at_price > variant.price
      ? formatMoney(variant.compare_at_price)
      : null;

    priceWrap.innerHTML = was
      ? `<span class="dm-price-now">${now}</span><span class="dm-price-was">${was}</span>`
      : `<span class="dm-price-now">${now}</span>`;
  }

  function updateATC(card, variant) {
    const btn = card.querySelector('[data-dm-atc]');
    const badge = card.querySelector('.dm-badge');
    if (!btn || !variant) return;

    const textAdd = btn.getAttribute('data-text-add') || 'Add to cart';
    const textSold = btn.getAttribute('data-text-soldout') || 'Sold out';

    if (variant.available) {
      btn.disabled = false;
      btn.textContent = textAdd;
      if (badge) badge.style.display = 'none';
    } else {
      btn.disabled = true;
      btn.textContent = textSold;
      if (badge) badge.style.display = '';
    }
  }

  function setVariant(card, variantId) {
    const variants = getVariants(card);
    const variant = variants.find((v) => String(v.id) === String(variantId));
    if (!variant) return;

    const input = card.querySelector('[data-dm-variant-input]');
    if (input) input.value = String(variant.id);

    updatePrice(card, variant);
    updateATC(card, variant);
  }

  async function addToCart(card, form) {
    const btn = card.querySelector('[data-dm-atc]');
    if (!btn || btn.disabled) return;

    const textAdd = btn.getAttribute('data-text-add') || 'Add to cart';
    const textAdding = btn.getAttribute('data-text-adding') || 'Adding…';
    const textAdded = btn.getAttribute('data-text-added') || 'Added ✓';
    const textError = btn.getAttribute('data-text-error') || 'Try again';

    btn.disabled = true;
    btn.textContent = textAdding;

    try {
      const fd = new FormData(form);
      const cartAddUrl =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd,
        credentials: 'same-origin',
      });

      if (!res.ok) throw new Error('add_failed');

      // Fetch the updated cart so the header/cart components get the correct item count immediately
      let cart = null;
      try {
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
        if (cartRes.ok) cart = await cartRes.json();
      } catch (e) {}

      // Trigger theme cart update so cart bubble / drawer updates without refresh
      try {
        const variantId = fd.get('id');
        const itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : undefined;

        const sourceId = (btn && (btn.id || btn.getAttribute('id'))) || 'dm-product-card-atc';

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId,
              data: {
                source: 'product-form-component',
                variantId: variantId ? String(variantId) : undefined,
                itemCount: typeof itemCount === 'number' ? itemCount : 0,
              },
            },
          })
        );
      } catch (e) {}

      // Fly-to-cart animation (matches theme behavior)
      try {
        const cartIcon = document.querySelector('.header-actions__cart-icon');
        const imgEl = card.querySelector('.dm-media-track img') || card.querySelector('img');
        const image = imgEl ? (imgEl.currentSrc || imgEl.src) : null;

        if (cartIcon && image) {
          const flyToCartElement = document.createElement('fly-to-cart');
          flyToCartElement.classList.add('fly-to-cart--quick');
          flyToCartElement.style.setProperty('background-image', `url(${image})`);
          flyToCartElement.style.setProperty('--start-opacity', '0');
          flyToCartElement.source = btn;
          flyToCartElement.destination = cartIcon;
          document.body.appendChild(flyToCartElement);
        }
      } catch (e) {}

      btn.textContent = textAdded;
      setTimeout(() => {
        // restore button state based on current variant availability
        const input = card.querySelector('[data-dm-variant-input]');
        if (input) setVariant(card, input.value);
        else {
          btn.disabled = false;
          btn.textContent = textAdd;
        }
      }, 900);
    } catch (e) {
      btn.textContent = textError;
      setTimeout(() => {
        const input = card.querySelector('[data-dm-variant-input]');
        if (input) setVariant(card, input.value);
        else {
          btn.disabled = false;
          btn.textContent = textAdd;
        }
      }, 900);
    }
  }

  function init() {
    const cards = Array.from(document.querySelectorAll('[data-dm-card]'));
    if (!cards.length) return;

    cards.forEach((card) => initCardCarousel(card));

    // Size switching
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-dm-variant]');
      if (!btn) return;

      const card = btn.closest('[data-dm-card]');
      if (!card) return;

      const all = Array.from(card.querySelectorAll('[data-dm-variant]'));
      all.forEach((b) => b.classList.toggle('is-active', b === btn));

      const variantId = btn.getAttribute('data-dm-variant');
      if (variantId) setVariant(card, variantId);
    });

    // AJAX add-to-cart
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('[data-dm-form]');
      if (!form) return;
      e.preventDefault();
      const card = form.closest('[data-dm-card]');
      if (!card) return;
      addToCart(card, form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
